var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ThemeProvider',{attrs:{"theme":"campsite"}},[_c('div',{attrs:{"id":"outer-container"}},[_c('Svgs'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('main',{attrs:{"id":"main"}},[_c('nuxt')],1),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }